<template>
  <div class="bouns single-input">
    <div class="d-flex input-head">
      <p class="input-name">紅利點數</p>
      <p>
        剩餘紅利點數
        <span class="red-text">{{ bonusParseInt }}</span>
        點
      </p>
    </div>
    <div class="">
      <input
        v-model="theBonusNum"
        type="number"
        :placeholder="`請輸入折抵點數${bonusDescription}`"
        v-validate="bonusInputRules"
        name="bonusNum"
        class="discount-text-input"
        min=0
        :class="{ 'wrong-border': errors.has('bonusNum') }"
        :disabled="bonusData.bonusTotal <= 0"
      />
      <span class="red-text">{{ errors.first('bonusNum') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['$validator'],
  props: {
    bonusData: {
      required: true,
      type: Object
    },
    value: {
      default: 0,
      required: false
    },
     bonusDescription:{
      type:String,
      required:true
    }
  },

  computed: {
    bonusInputRules() {
      return `max_value:${this.bonusParseInt}`;
    },
    theBonusNum: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', parseInt(value) ? parseInt(value) : '');
      }
    },
    bonusParseInt(){
      return parseInt(this.bonusData.bonusTotal);
    }
  },
  created() {
    const dict = {
      custom: {
        bonusNum: {
          max_value: function(n, e) {
            return '您的' + n + ' 現在只有 ' + e[0] + '點。'; //custom 中設定 錯誤訊息返回的字串  n是input name e是定義的規則
          }
        }
      },
      attributes: {
        bonusNum: '紅利點數' //attribute 中設定 input name的中文
      }
    };
    this.$validator.localize('zh_TW', dict);
  },
};
</script>
